import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue";
  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { BuilderInterface } from "@/types/BuilderInterface";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import BuilderEstimatorQuoteSummaryMobileCollapse from "@/components/builder/estimator-tool/BuilderEstimatorQuoteSummaryMobileCollapse.vue";
  import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorMobileHeader',
  props: {
    builder: {
      type: Object as PropType<BuilderInterface>,
      default: null,
    },
    totalPrice: {
      type: String,
      default: "$0",
    },
    currentStep: {
      type: String as PropType<BuilderEstimatorSteps>,
      default: BuilderEstimatorSteps.LAND_DETAILS,
    },
  },
  emits: ["toggle-summary-modal"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(980);

  const props = __props;

  const emit = __emit;

  const toggleSummaryModal = () => {
    emit("toggle-summary-modal");
  };

const __returned__ = { isDesktop, props, emit, toggleSummaryModal, PropType, ref, InputSearch, get EstateInterface() { return EstateInterface }, get BuilderInterface() { return BuilderInterface }, get useIsDesktop() { return useIsDesktop }, BuilderEstimatorQuoteSummaryMobileCollapse, get BuilderEstimatorSteps() { return BuilderEstimatorSteps } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})